function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.772 20.786c.589 0 1-.476 1.276-1.2l4.983-13.04a2.537 2.537 0 0 0 .2-.883.819.819 0 0 0-.883-.876 2.545 2.545 0 0 0-.884.2L5.376 10c-.649.249-1.14.657-1.14 1.246 0 .717.536.989 1.276 1.216l3.911 1.193a1.035 1.035 0 0 0 1.208-.189l8.411-7.796a.226.226 0 0 1 .317-.008.217.217 0 0 1-.007.31L11.575 14.4a1.106 1.106 0 0 0-.189 1.216l1.163 3.836c.226.768.498 1.334 1.223 1.334z",
  transform: "translate(-4.235 -4.786)"
});

function SvgFilledSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledSend);
export default __webpack_public_path__ + "static/media/filled-send.d79de6df.svg";
export { ForwardRef as ReactComponent };